import Lenis from "lenis";

const lenis = new Lenis({
  lerp: 0.09,
  smoothWheel: true,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

export default lenis;
